export default class Parallax {
    constructor() {
        const containers = document.querySelectorAll('.js-parallax');
        containers.forEach((container) => {
            const target = container.querySelector('.parallax-bg');
            window.addEventListener('scroll', () => {
                const scrollY = container.getBoundingClientRect().y;
                target.style.top = `${scrollY * -0.125}px`;
            });
        });
    }
}
